import {
  Box, DashboardModule, Form,
} from '@domain-group/suit-theme'

import handleCallbackAction from '@functions/handleCallbackAction'

import useAdCopy, { useAdCopyForm } from '@hooks/useAdCopy'

import type { AdCopyModel } from '@models/types'

import AdCopyItemHeader from '@components/AdCopyItemHeader'

interface AdCopyItemParams {
  adCopy: Partial<AdCopyModel>,
  campaignId: number,
  title: 'Default' | 'Digital' | 'Editorial' | 'Newspaper' | 'Print' | 'Signboards',
}

const AdCopyItem = (props: AdCopyItemParams) => {
  const { adCopy, campaignId, title } = props

  const adCopyPayload = useAdCopy(adCopy)
  const {
    callbacks: {
      createOrUpdateAdCopy,
      reviewAdCopyRequests,
    },
  } = adCopyPayload

  const {
    entityState,
    entityState: { tagline, description },
    handlers,
  } = useAdCopyForm(adCopy)

  const createOrUpdateAdCopyPayload = {
    callbacks: {
      action: createOrUpdateAdCopy,
    },
    entityParams: entityState,
    toastText: 'Ad Copy Updated',
  }

  const disableAdCopy = adCopy.review_status === 'approved' || adCopy.copied_to_campaign

  return (
    <DashboardModule
      headerRight={!!adCopy?.order_item_id && (
        <AdCopyItemHeader
          adCopy={adCopy}
          campaignId={campaignId}
          commentsCallback={() => reviewAdCopyRequests(campaignId)}
        />
      )}
      key={adCopy.id}
      title={title}
    >
      <Box flexDirection="column" padding="large">
        <Form.Field label="Tagline">
          <input
            disabled={disableAdCopy}
            name="tagline"
            onBlur={() => handleCallbackAction(createOrUpdateAdCopyPayload)}
            onChange={handlers.onChange}
            type="text"
            value={tagline}
          />
        </Form.Field>

        <Form.Field label="Description" marginTop="large">
          <textarea
            disabled={disableAdCopy}
            name="description"
            onBlur={() => handleCallbackAction(createOrUpdateAdCopyPayload)}
            // @ts-expect-error TS2322
            onChange={handlers.onChange}
            value={description}
            style={{ minHeight: 120, resize: 'vertical' }}
          />
        </Form.Field>
      </Box>
    </DashboardModule>
  )
}

export default AdCopyItem
